import React from "react";
import "./consent.css";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import CommentIcon from "@material-ui/icons/Comment";
import { Button } from "@material-ui/core/";
interface IProps {
  setConsent: (consent: boolean) => void;
  consent: boolean;
}
export const ConsentContent: React.FC<IProps> = (props: IProps) => {
  const [allChecked, setAllChecked] = React.useState<number>(0);
  const [showRejectText, setShowRejectText] = React.useState<boolean>(false);
  const [render, reRender] = React.useState<boolean>(false);
  return (
    <div className="content_container">
      <p style={{ color: "#595959" }} className="consent_text">
        Before you can undertake the Performance Tracker please review the
        following ethics information which you are required to consent to in
        order to participate in the project
      </p>

      <h4 className="consent_h4">Taking part</h4>
      <List style={{ color: "#595959" }} dense={true}>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I have read and understood the Participant Information Sheet. I have been given the opportunity to ask questions about the project."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I understand that taking part is voluntary and that I may withdraw from the project at any time. I do not have to give any reason for why I no longer want to take part."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I agree to take part in the project, and provide feedback through the templates."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <h4 className="consent_h4">Use of my data</h4>
      <List style={{ color: "#595959" }} dense={true}>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I understand that particular contact information that I have provided to the University of Southampton will be collected to achieve the objectives of the study as detailed in the Participant Information Sheet."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <h4 className="consent_h4">
        Use of information I provide for this project only
      </h4>
      <List style={{ color: "#595959" }} dense={true}>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I understand that my comments (in templates or discussions) may be quoted in publications and research work, any use of this data will be pseudonymised (artificial identifiers will replace personal/organisational identification) with all personal details removed."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <h4 className="consent_h4">
        Use of the information I provide beyond this point
      </h4>
      <List style={{ color: "#595959" }} dense={true}>
        <ListItem>
          <ListItemText
            className="consent_text"
            id=""
            primary={
              "I understand that pseudonymised data may be used for research purposes by named project partners and researchers."
            }
          />
          <ListItemSecondaryAction>
            <Checkbox
              checked={props.consent ? true : undefined}
              style={{ color: "#44B8A8" }}
              onChange={(e) => {
                e.target.checked
                  ? setAllChecked(allChecked + 1)
                  : setAllChecked(allChecked - 1);
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
      <Button
        id="consent_button"
        disabled={allChecked !== 6}
        onClick={() => {
          props.setConsent(true);
        }}
      >
        Consent
      </Button>
      <Button
        id="consent_button"
        style={{ marginLeft: 10, background: "red" }}
        onClick={() => {
          setShowRejectText(true);
          props.setConsent(false);
          reRender(!render)
        }}
      >
        Reject Consent
      </Button>
      <br />
      <span style={{ color: "#595959", paddingLeft: 16, fontSize: "0.875rem" }}>
        {showRejectText
          ? "If you do not consent, please contact EMAIL ADDRESS to discuss your concerns as consent is required to participate in the assessment."
          : null}
      </span>
    </div>
  );
};
